import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface AdminProfile {
  id: string;
  name: string;
  role: string;
}

interface AuthState {
  token: string | null;
  admin: AdminProfile | null;
  isAuthenticated: boolean;
  setAuth: (token: string, admin: AdminProfile) => void;
  logout: () => void;
}

/**
 * Admin auth store — zustand + localStorage persist. Replaces the Next.js
 * cookie/middleware auth; the router's ProtectedRoute guards on isAuthenticated.
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      admin: null,
      isAuthenticated: false,
      setAuth: (token, admin) => set({ token, admin, isAuthenticated: true }),
      logout: () => set({ token: null, admin: null, isAuthenticated: false }),
    }),
    { name: "aquapay-admin-auth" }
  )
);
